<!--
 * @Author: Tahiti
 * @Date: 2025-10-21 15:03:16
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-11-20 15:38:56
 * @Description: 
 * @FilePath: /weryai-web/components/Tool/VideoAudio.vue
-->
<template>
    <div class="mt-5">
        <div
            class="flex items-center justify-between gap-2 p-[10px] rounded-[10px] bg-tool-default-black border border-white/[.06]"
        >
            <label class="flex items-center text-white text-sm" :id="labelId">
                {{ t('tools.generateAudio') }}
            </label>
            <div class="flex justify-center items-center gap-[10px]">
                <button
                    @click="generate_audio = !generate_audio"
                    type="button"
                    role="switch"
                    :aria-checked="generate_audio"
                    :aria-labelledby="labelId"
                    class="relative inline-flex h-6 w-11 items-center rounded-full transition-all duration-300"
                    :class="
                        generate_audio ? 'bg-switch-active-bg' : 'bg-white/10'
                    "
                >
                    <!-- 兜底：确保按钮始终有可访问名称（Lighthouse/axe 兼容） -->
                    <span class="sr-only">
                        {{ t('tools.generateAudio') }}
                    </span>
                    <span
                        class="inline-block h-4 w-4 transform rounded-full transition-transform"
                        :class="
                            !generate_audio
                                ? 'translate-x-1 bg-white'
                                : 'translate-x-6 bg-switch-active-dot'
                        "
                    ></span>
                </button>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { useId } from 'vue'
import { useI18n } from '../../composables/useI18n'

const { t, locale } = useI18n()
const labelId = useId()

const generate_audio = defineModel('generate_audio', {
    type: Boolean,
    default: true,
})
</script>
<style scoped lang="less">
.hidden-scrollbar {
    display: flex;
    gap: 10px;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    &::-webkit-scrollbar {
        display: none; /* Chrome, Safari and Opera */
    }
}
</style>
